<template>
  <div id="tracker-page">
    <div @mouseover="closeAllModals($event)" id="bg">
    </div>
    <div class="wrapper">
      <div v-if="list">
        <header-bar :logo="`https://trackers.kpam.fr/images/customer/logo/${list.customerId}`" :isRh="list.isKpamRH" :title="list.name" :pdf="list.pdfDocumentPath" :report="list.reportDocumentPath"></header-bar>
        <tracker-caption :comparative="list.isComparative"></tracker-caption>
        <tracker :max="max" :comparative="list.isComparative" :list="list.touchpoints"></tracker>
      </div>
      <div v-else>
        <loading :loading="true"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import Tracker from "@/components/Tracker";
import HeaderBar from "@/components/HeaderBar";
import TrackerCaption from "@/components/TrackerCaption";
import TrackersList from "@/components/TrackersList";

import api from "../api";
export default {
  name: "app",
  data() {
    return {
      list: null,
      trackers: null,
      max: 0
    };
  },
  components: {
    Tracker,
    HeaderBar,
    TrackerCaption,
    TrackersList
  },
  computed: {},
  mounted() {
    api
      .getTracker(1)
      .then(res => {
        console.log(res);
        this.list = res;
        this.list.touchpoints.forEach((e, i) => {
          if (this.max < Math.abs(e.negativeIntensity)) {
            this.max = Math.abs(e.negativeIntensity);
          }
          if (this.max < Math.abs(e.positiveIntensity)) {
            this.max = Math.abs(e.positiveIntensity);
          }
        });
        this.max = this.max + 5;
      })
      .catch(e => {
        console.log(e);
      });
  },
  beforeCreate() {
    document.title = this.$t("titles.tracker");
  },
  methods: {
    closeAllModals(event) {
      var els = document.getElementsByClassName("modal");
      var items = document.getElementsByClassName("item-tracker");
      Array.prototype.forEach.call(els, el => {
        el.classList.remove("active");
      });
      Array.prototype.forEach.call(items, el => {
        el.classList.remove("is-active");
      });
      event.currentTarget.classList.remove("active");
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/css/variables.scss";
.wrapper {
}
</style>
